import { render, staticRenderFns } from "./classroom-task.vue?vue&type=template&id=417be18e&scoped=true"
import script from "./classroom-task.vue?vue&type=script&lang=js"
export * from "./classroom-task.vue?vue&type=script&lang=js"
import style0 from "./classroom-task.vue?vue&type=style&index=0&id=417be18e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417be18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417be18e')) {
      api.createRecord('417be18e', component.options)
    } else {
      api.reload('417be18e', component.options)
    }
    module.hot.accept("./classroom-task.vue?vue&type=template&id=417be18e&scoped=true", function () {
      api.rerender('417be18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/classroom-task.vue"
export default component.exports